import PropTypes from "prop-types"

import "./style.scss"

export default function ErrorModelAccess({ modelId, children }) {
  return <div className="component_error-model-access">
    <div className="text">
      <h1>This page is currently not available</h1>
      <p>You do not have access to the risk model {modelId} associated with this link. Please <b>change the risk model selection to view this page</b>.</p>
      {children && <div className="recovery">{children}</div>}
      <p className="note">Note, if someone shared this link with you to showcase a particular insight, changing the risk model may change the contents of this page.</p>
    </div>
    <div className="image">
      <img src="https://assets.ompnt.com/images/op-data-bouncer.png" width="60%" />
    </div>
  </div>
}

ErrorModelAccess.propTypes = {
  modelId: PropTypes.string.isRequired,
  // The way out of the dead end, when the caller has one to offer.
  children: PropTypes.node,
}
